var map = {
	"./br/PT/S1/bg70.jpg": 42068,
	"./br/PT/bg70.jpg": 17515,
	"./in/EN/S1/bg70.jpg": 16835,
	"./ph/EN/S1/bg70.jpg": 28384,
	"./ph/EN/bg70.jpg": 62901,
	"./vn/VI/S1/bg70.jpg": 26023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2781;